namespace Matrix.Data {
    export interface AccountRoleForm {
        AccountRoleCode: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class AccountRoleForm extends Serenity.PrefixedContext {
        static formKey = 'Data.AccountRole';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AccountRoleForm.init)  {
                AccountRoleForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = StaticTextBlock;
                var w2 = ReadOnlyDateTime;

                Q.initFormType(AccountRoleForm, [
                    'AccountRoleCode', w0,
                    'Name', w0,
                    'CreatedBy', w1,
                    'CreatedWhen', w2,
                    'UpdatedBy', w1,
                    'UpdatedWhen', w2,
                    'Version', w1
                ]);
            }
        }
    }
}
